import React from 'react'
import { Field } from 'formik'

export const Radio = props => {
    return (
        <>
            {props?.label?.length > 0 && props?.type !== 'hidden' && (
                <p className="mb-[8px]">
                    {props.label}
                    {props.required && <sup className="text-brand-danger">*</sup>}
                </p>
            )}
            {props?.options?.length > 0 && (
                <Field name={props.name}>
                    {({ field, form }) => (
                        <div className="mb-[15px]">
                            {props.options.map((option, idx) => (
                                <div
                                    className={`flex items-center cursor-pointer ${
                                        idx > 0 ? 'mt-[10px]' : 'mt-0'
                                    }`}
                                    key={option.value}
                                >
                                    <input
                                        type="radio"
                                        id={option.value.replaceAll(' ', '-')}
                                        {...field}
                                        value={option.value}
                                        disabled={form.isSubmitting}
                                        checked={field.value === option.value}
                                        onChange={e =>
                                            form.setFieldValue(field.name, e.target.value)
                                        }
                                        style={{
                                            boxShadow:
                                                field.value === option.value
                                                    ? 'inset 0 0 0px 2px #fff'
                                                    : 'none',
                                        }}
                                        class="appearance-none w-4 h-4 !border rounded-full checked:border-brand-secondary checked:bg-brand-secondary mr-[10px]"
                                    />

                                    {option.label.length > 0 && (
                                        <label
                                            className="mb-0 text-sm cursor-pointer"
                                            htmlFor={option.value.replaceAll(' ', '-')}
                                        >
                                            {option.label}
                                        </label>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </Field>
            )}
            {props?.help?.length > 0 && props?.type !== 'hidden' && (
                <p className="text-brand-dark-grey text-[12px] mb-[15px] md:mb-[30px]">
                    {props.help}
                </p>
            )}
        </>
    )
}
